import { AiOutlineArrowRight } from "react-icons/ai";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NewsSlider = () => {

  const izbNewsSlider31 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia-thumb.webp";

  const izbNewsSlider32 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-thumb.jpg"

  const izbNewsSlider33 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-csr-medical-equipment-thumb.jpg"
  const izbNewsSlider34 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/MoF_news.01AM.jpeg"
  const izbNewsSlider35 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZBFRA2026.jpeg"

  const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
  const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";


  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <img
        src={ArrowLeft}
        className={className}
        style={{
          ...style,
          display: "block",
          width: "50px",
          height: "50px",
          left: "-58px",
          zIndex: "99"
        }}
        onClick={onClick}
      />
    );
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <img
        src={ArrowRight}
        className={className}

        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="news-slider-main">
      <div className="container">
        <div className="row">
          <div className="container">
            <div className="heading pt-5">
              <h1 className="text-center">Latest News</h1>
              <p className="text-center pt-2">All News And Updates</p>
            </div>
            <div
              className="py-4 read-more-flot-btn"
            >
              <Link
                to="/LatestNews"
                className="text-white rounded px-3 pt-1 pb-2"
                style={{ backgroundColor: "#9E1B1E" }}
              >
                View All <AiOutlineArrowRight size={21} className="me-1 pb-1" />
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 hide-on-tablet">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="/indo-zambia-bank-delegation-paid-a-courtesy-call-to-the-food-reserve-agency" style={{ textTransform: "none" }}>
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={izbNewsSlider35} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-0 text-left">
                  <a href="/indo-zambia-bank-delegation-paid-a-courtesy-call-to-the-food-reserve-agency" style={{ textTransform: "none" }}>
                    Indo Zambia Bank delegation paid a courtesy call to the...
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>February 4, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                  The Indo Zambia Bank delegation, led by our Managing Director Mr. Brajesh Kumar Singh, paid a courtesy call to the Food Reserve Agency (FRA), hosted by Executive Director Justin Chuunka and his team...

                </p>
                <a href="/indo-zambia-bank-delegation-paid-a-courtesy-call-to-the-food-reserve-agency">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-6 hide-on-tablet">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="/indo-zambia-bank-was-proud-to-sponsor-and-participate-in-the-2026-zambia-economic-forum" style={{ textTransform: "none" }}>
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={izbNewsSlider34} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-0 text-left">
                  <a href="/indo-zambia-bank-was-proud-to-sponsor-and-participate-in-the-2026-zambia-economic-forum" style={{ textTransform: "none" }}>
                    Indo Zambia Bank was proud to sponsor and participate...
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>February 2, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                  We commend the Ministry for the notable economic reforms and achievements recorded between 2021 and 2025, particularly in restoring fiscal discipline, strengthening transparency and laying the foundation for...
                </p>
                <a href="/indo-zambia-bank-was-proud-to-sponsor-and-participate-in-the-2026-zambia-economic-forum">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-6 hide-on-tablet">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://youtu.be/7HwteoItStI" target="_blank">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={izbNewsSlider33} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-0 text-left">
                  <a href="https://youtu.be/7HwteoItStI" target="_blank" style={{ textTransform: "none" }}>
                    Indo Zambia Bank – Landmark CSR Project, delivers...
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>November 18, 2025</span>
                </h3>
                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                  Indo Zambia Bank has reaffirmed its commitment to national development through major CSR investments in the health sector. With donations totaling over K1.5 million, we equipped the Zambia Flying Doctor Service...
                </p>
                <a href="https://youtu.be/7HwteoItStI" target="_blank">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="test show-on-tablet news-slider-list-slider row align-items-center">
            <Slider {...settings}>

              <div className="">
                <div
                  className="single-blog-style1 wow fadeInUp"
                  data-wow-delay="00ms"
                  data-wow-duration="1500ms"
                >
                  <a href="https://youtu.be/7HwteoItStI" target="_blank">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider33} alt="" />
                        <div className="overlay-icon"></div>
                      </div>
                    </div>
                  </a>
                  <div className="text-holder">
                    <h3 className="blog-title mt-0 text-left">
                      <a href="https://youtu.be/7HwteoItStI" target="_blank">
                           Indo Zambia Bank – Landmark CSR Project, delivers...
                      </a><br />
                      <span style={{ fontSize: "15px", color: "gray" }}>November 18, 2025</span>
                    </h3>
                    <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                           Indo Zambia Bank has reaffirmed its commitment to national development through major CSR investments in the health sector. With donations totaling over K1.9 million, we equipped the Zambia Flying Doctor Service...
                    </p>
                    <a href="https://youtu.be/7HwteoItStI" target="_blank">
                      <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                        Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                      </h5>
                    </a>
                    <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                  </div>
                </div>
              </div>

              <div className="">
                <div
                  className="single-blog-style1 wow fadeInUp"
                  data-wow-delay="00ms"
                  data-wow-duration="1500ms"
                >
                  <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider32} alt="" />
                        <div className="overlay-icon"></div>
                      </div>
                    </div>
                  </a>
                  <div className="text-holder">
                    <h3 className="blog-title mt-0 text-left">
                      <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital">
                          Indo Zambia Bank officially hands over essential...
                      </a><br />
                      <span style={{ fontSize: "15px", color: "gray" }}>November 17, 2025</span>
                    </h3>
                    <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                           Indo Zambia Bank proudly reaffirmed its commitment to healthcare by officially handing over essential medical equipment to the Ministry of Health at Ndola Teaching Hospital (NTH) valued at over ZMW 422,000...
                    </p>
                    <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital">
                      <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                        Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                      </h5>
                    </a>
                    <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                  </div>
                </div>
              </div>

              <div className="">
                <div
                  className="single-blog-style1 wow fadeInUp"
                  data-wow-delay="00ms"
                  data-wow-duration="1500ms"
                >
                  <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider31} alt="" />
                        <div className="overlay-icon"></div>
                      </div>
                    </div>
                  </a>
                  <div className="text-holder">
                    <h3 className="blog-title mt-0 text-left">
                      <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                          Indo Zambia Bank proudly reaffirmed its commitment...
                      </a><br />
                      <span style={{ fontSize: "15px", color: "gray" }}>November 15, 2025</span>
                    </h3>
                    <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank is proud to have officially handed over a fully furbished and equipped state-of-the-art Theatre unit and Dental unit, valued at over ZMW 1 million, to The Ministry of Health at The Zambia Flying Doctors...
                    </p>
                    <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                      <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                        Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                      </h5>
                    </a>
                    <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                  </div>
                </div>
              </div>

            </Slider>
          </div>

        </div>
      </div>
    </section>
  );
};

export default NewsSlider;